import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10" {...props}>
    <path d="m1.572 9.515 4.417-4.447L1.497.548" />
  </svg>
);

export default SvgLink;
